// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ab728a95","513":"41e5e4dc","703":"5287bddb","787":"920d0757"}[chunkId] + ".chunk.js";
};